import { Helpers } from '../../helpers';
import { IConstraintPrematureWellShutdown } from '../../interfaces/iconstraint-premature-well-shutdown';
import { ConstraintPrematureWellShutdownDetail } from '../constraint-premature-well-shutdown-detail';
import { Scenario } from '../scenario';

export class ConstraintPrematureWellShutdownBase {
  ConstraintPrematureWellShutdownId: number;
  ScenarioId: number;
  EffectiveStartDate: Date | null;
  EffectiveEndDate: Date | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ConstraintPrematureWellShutdownDetails_ConstraintPrematureWellShutdown?: Array<ConstraintPrematureWellShutdownDetail> | null;
  Scenario?: Scenario;

  constructor(item?: IConstraintPrematureWellShutdown) {
    if (item) {

      this.ConstraintPrematureWellShutdownId = item.ConstraintPrematureWellShutdownId;
      this.ScenarioId = item.ScenarioId;
      this.EffectiveStartDate = item.EffectiveStartDate ? new Date(item.EffectiveStartDate) : null;
      this.EffectiveEndDate = item.EffectiveEndDate ? new Date(item.EffectiveEndDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ConstraintPrematureWellShutdownDetails_ConstraintPrematureWellShutdown = Helpers.createClassArray(ConstraintPrematureWellShutdownDetail, item.ConstraintPrematureWellShutdownDetails_ConstraintPrematureWellShutdown);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}